<template>
	<div v-show="showButton" class="back-to-top" @click="scrollToTop" @mouseover="isHover = true"
		@mouseleave="isHover = false">
		<!-- <img src="@/assets/totop.png" alt="返回顶部" class="top-img" /> -->
		<img :src="isHover ? require('@/assets/totop-hover.png') : require('@/assets/totop.png')" alt="返回顶部"
			class="top-img" />

	</div>
</template>

<script>
	export default {
		data() {
			return {
				isHover: false,
				showButton: false,

			};
		},
		methods: {
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			},
			handleScroll() {
				this.showButton = window.scrollY > 200;
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		}
	};
</script>

<style scoped>
	.back-to-top {
		position: fixed;
		right: 24px;
		bottom: 80px;

		cursor: pointer;
		z-index: 999;

		/* Rectangle 24706 */


		width: 48px;
		height: 48px;


		background: #FFFFFF;
		box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
		border-radius: 12px;

		user-select: none;
		/* 标准语法 */
		-webkit-user-select: none;
		/* Chrome、Safari */
		-moz-user-select: none;
		/* Firefox */
		-ms-user-select: none;
		/* IE/Edge */



	}

	.top-img {

		display: block;
		margin-top: 12px;
		margin-left: 12px;
		width: 24px;
		height: 24px;



	}
</style>